import './styles.scss'
import { CONFIG_APP } from '@constants/constants'

function Footer() {
  return <div className='footer'>Copyright © 2022 {CONFIG_APP.nameApp}</div>
}

export default Footer
